<script>
  import { quest, quests } from "../taskTipStore.js";

  $: someTestJSON = JSON.stringify($quests, null, 2);

  function selectQuest(id) {
    quest.setQuestId(id);
  }

  function addQuest() {
    let newQuest = {
      //   id: Math.round(Math.random() * 1000000), // will autogenerate
      name: "Новый квест",
      tasks: [],
      tips: []
    };

    quests.addQuest(newQuest);
  }
</script>

<style>
  button {
    background-color: #eee;
    border: 0;
    border-radius: 5px;
    color: #fff;
  }

  button.current {
    background-color: blue;
  }

  button.add {
    background-color: orangered;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 220px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -110px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: small;
  }

  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
</style>

{#each $quests as q, i (q.id)}
  <div class="tooltip">
    <button
      class:current={$quest.id == q.id}
      on:click={() => selectQuest(q.id)}>
      {q.name}
    </button>
    <span class="tooltiptext">{q.id}</span>
  </div>
  <br />
{:else}
  Загружается список Квестов...
  <br />
{/each}
<button class="add" on:click={() => addQuest()}>+</button>
